var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51956 4.23483C8.51956 3.68255 8.06966 3.22762 7.52283 3.30503C6.47016 3.45405 5.45986 3.83791 4.56884 4.43327C3.39942 5.21465 2.48797 6.32525 1.94975 7.62464C1.41153 8.92402 1.2707 10.3538 1.54509 11.7333C1.81947 13.1127 2.49674 14.3798 3.49124 15.3743C4.48575 16.3688 5.75283 17.046 7.13225 17.3204C8.51167 17.5948 9.94148 17.454 11.2409 16.9158C12.5402 16.3775 13.6509 15.4661 14.4322 14.2967C15.0276 13.4056 15.4115 12.3953 15.5605 11.3427C15.6379 10.7958 15.183 10.3459 14.6307 10.3459H10.0196C9.19113 10.3459 8.51956 9.67437 8.51956 8.84594V4.23483Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1862 2.45703C11.1862 1.90475 11.6368 1.44884 12.1819 1.53722C12.6563 1.61412 13.1213 1.7459 13.5674 1.93067C14.3223 2.24337 15.0082 2.70169 15.586 3.27948C16.1638 3.85727 16.6221 4.5432 16.9348 5.29811C17.1196 5.74418 17.2514 6.20917 17.3283 6.68355C17.4166 7.22871 16.9607 7.67925 16.4084 7.67925L12.1862 7.67925C11.6339 7.67925 11.1862 7.23154 11.1862 6.67925V2.45703Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.23a09f7abf8a621f62e52959c63ca78a.svg";
export { ForwardRef as ReactComponent };